// extracted by mini-css-extract-plugin
export default {"main":"Completion_main__xpBAW"};